import { render, staticRenderFns } from "./Rich.vue?vue&type=template&id=3924475c&scoped=true&"
import script from "./Rich.vue?vue&type=script&lang=js&"
export * from "./Rich.vue?vue&type=script&lang=js&"
import style0 from "./Rich.vue?vue&type=style&index=0&id=3924475c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924475c",
  null
  
)

export default component.exports